export enum verbeHttpType {
  DELETE = 'delete',
  FILE = 'file',
  GET = 'get',
  POST = 'post',
  PATCH = 'patch',
}
